export default "__VITE_ASSET__7bb61c5b__"